module.exports = __webpack_public_path__ + "assets/img/access.387779a5.svg";